import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const setAnswer = api((id, type, question, answer) =>
    mutate(
        gql`
            mutation SetQuestionAnswer($id: String!, $type: String!, $question: String!, $answer: String) {
                setAssetTypeQuestionAnswer(id: $id, type: $type, question: $question, answer: $answer)
            }
        `,
        { id, type, answer, question },
        { returns: "setAssetTypeAnswer" }
    )
)
